module.exports = __webpack_public_path__ + "assets/dashboard.78da5d2d.svg";